import { render } from "./coordenadores-all.vue?vue&type=template&id=26d0aa22&scoped=true"
import script from "./coordenadores-all.vue?vue&type=script&lang=js"
export * from "./coordenadores-all.vue?vue&type=script&lang=js"

import "./coordenadores-all.vue?vue&type=style&index=0&id=26d0aa22&lang=scss&scoped=true"
import "./coordenadores-all.vue?vue&type=style&index=1&id=26d0aa22&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d0aa22"]])

export default __exports__